import styled from '@emotion/styled';
import Link, { type LinkProps } from '@mui/material/Link/Link';

const StyledLink = styled(Link)`
  font-weight: 600;
  font-family: 'Ubuntu', sans-serif;
  text-decoration: underline !important;
`;

export const MHMHyperlink = ({ children, ...props }: LinkProps) => {
  return (
    <StyledLink color="primary" {...props}>
      {children}
    </StyledLink>
  );
};
